module.exports = __webpack_public_path__ + "img/Economics Urdu Medium.42ed2e19.jpg";